import { Box, Flex, Icon, Image } from '@energiebespaarders/symbols';
import { CaretRight, CaretUp, Home } from '@energiebespaarders/symbols/icons/line';
import { useRouter } from 'next/router';
import HybridLink from '~/components/HybridLink';
import { formatBreadCrumb, formatPathnames, generateUrl } from './FaqBreadCrumbs';

import CircleMobileMenu from '/public/img/CircleMobileMenu.svg';

interface MobileBreadCrumbsProps {
  expandMobileMenu: boolean;
  setExpandMobileMenu: React.Dispatch<React.SetStateAction<boolean>>;
}

const MobileBreadCrumbs: React.FC<MobileBreadCrumbsProps> = ({
  expandMobileMenu,
  setExpandMobileMenu,
}) => {
  const router = useRouter();

  const pathnames = formatPathnames(router.asPath);
  const currentBreadCrumb = pathnames[pathnames.length - 1];

  return (
    <Box>
      <Flex alignItems="center">
        {!expandMobileMenu ? (
          <>
            <HybridLink to={'/faq'}>
              <Icon icon={Home} />
            </HybridLink>
            <Icon icon={CaretRight} mx={2} />
            <Image
              onClick={() => setExpandMobileMenu(!expandMobileMenu)}
              src={CircleMobileMenu}
              alt="mobile menu"
              style={{ maxHeight: '100%', maxWidth: '240px', color: 'red' }}
            />
            <Icon icon={CaretRight} mx={2} />
            <HybridLink style={{ color: 'black' }} to={generateUrl(currentBreadCrumb, pathnames)}>
              {formatBreadCrumb(currentBreadCrumb)}
            </HybridLink>
          </>
        ) : (
          <>
            <Image
              onClick={() => setExpandMobileMenu(!expandMobileMenu)}
              src={CircleMobileMenu}
              alt="mobile menu"
              style={{ maxHeight: '100%', maxWidth: '240px', color: 'red' }}
            />
            <Icon icon={CaretUp} mx={2} onClick={() => setExpandMobileMenu(!expandMobileMenu)} />
          </>
        )}
      </Flex>

      {expandMobileMenu && (
        <Flex flexDirection="Column">
          {pathnames.map((p, i) => {
            return p === 'faq' ? null : (
              <Box key={`crumb-${i}`} py={2}>
                <HybridLink to={generateUrl(p, pathnames)} style={{ color: 'black' }}>
                  {formatBreadCrumb(p)}
                </HybridLink>
              </Box>
            );
          })}
        </Flex>
      )}
    </Box>
  );
};

export default MobileBreadCrumbs;
